<div class="w-full max-w-lg">
  <ng-container *ngFor="let ticket of ticketTypes">
    <label
      class="flex items-center justify-between border p-3 mb-3 rounded-lg transition-shadow duration-200 hover:shadow-md"
      (click)="onTicketChange(ticket)"
      [ngClass]="{
        'border-orange-700 border-2': isSelected(ticket),
        'cursor-pointer': isTicketAddable(ticket),
        'cursor-not-allowed opacity-60': !isTicketAddable(ticket)
      }"
    >
      <input
        type="radio"
        name="ticketType"
        [value]="ticket"
        [disabled]="!isTicketAddable(ticket)"
        class="h-4 w-4 text-black mr-3"
        [ngClass]="isTicketAddable(ticket) ? 'cursor-pointer' : 'cursor-not-allowed'"
        [checked]="isSelected(ticket)"
      />

      <div class="flex flex-col flex-1 text-left">
        <span class="text-sm font-semibold" *ngIf="!ticket.free">{{
          ticket.price | currency : ticket.currencyCode
        }}</span>
        <span class="text-sm font-semibold" *ngIf="ticket.free">Free</span>
        <span class="text-xs text-gray-500">{{ ticket.name }}</span>
      </div>

      <!-- Ticket Status Tags -->
      <div class="ml-2">
        <nz-tag
          *ngIf="getTicketStatusBadge(ticket)"
          [nzColor]="getTicketStatusBadge(ticket)?.color"
          class="text-xs"
        >
          {{ getTicketStatusBadge(ticket)?.text }}
        </nz-tag>
      </div>
    </label>
  </ng-container>
</div>
